var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullBoxVue',{staticClass:"shadowHover"},[_c('hello-world')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }